import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from './shared/services/custom-translate-loader.service';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { interceptorProviders } from './interceptors/interceptors';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoogleTagManagerModule } from "angular-google-tag-manager";
import { CookieService } from 'ngx-cookie-service';
import { APP_CONFIG, AppConfig } from './shared/services/config-initialization.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { register } from 'swiper/element/bundle';
import { SwiperDirective } from './shared/directives/swiper.directive';
// register Swiper custom elements
register();

import { AppInitService } from './shared/services/app-init.service';
import { ShellComponentsModule } from './shared/components/shell-components.module';

export function initializeApp(appInitService: AppInitService): () => Promise<void> {
  return () => appInitService.initialize();
}

@NgModule({
  declarations: [AppComponent, SwiperDirective],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios',
      animated: false
    }),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient, APP_CONFIG]
      }
    }),
    BrowserAnimationsModule,
    MatTooltipModule,
    ShellComponentsModule,
    ServiceWorkerModule.register('service-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:5000'
    }),
    GoogleTagManagerModule.forRoot({
      id: '',
      gtm_resource_path: 'googleTagManagerPath'
    })
  ],
  providers: [
    DatePipe,
    HttpClient,
    CookieService,
    interceptorProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: 'googleTagManagerId',  useFactory: (config: AppConfig) => config.googleManagerId, deps: [APP_CONFIG]},
    { provide: 'googleTagManagerPath', useFactory: (config: any) => config.googleManagerPath, deps: [APP_CONFIG]},
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
